// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"hBgtDBDL","download":"Y0sq5dm5","more":"jYxoKC0_","icon":"Bn9p7exa","menu":"jCWGb3QD","link":"jZIu18yZ","logo":"_ij7oYBH","text":"Ofrr17II"};